// // Save data to sessionStorage
// sessionStorage.setItem("key", "value");

// // Get saved data from sessionStorage
// let data = sessionStorage.getItem("key");

// // Remove saved data from sessionStorage
// sessionStorage.removeItem("key");

// // Remove all saved data from sessionStorage
// sessionStorage.clear();

export const setSession = (key, value) => {
  try {
    return window?.sessionStorage?.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.log(`Failed to write 'sessionStorage' data:  ${error}`)
    return null
  }
}

export const getSession = (key = '') => {
  try {
    return JSON.parse(window?.sessionStorage?.getItem(key)) || null
  } catch (error) {
    console.log(`Failed to convert 'sessionStorage' data:  ${error}`)
    return null
  }
}

export const removeSession = (key) => {
  try {
    return window?.sessionStorage?.removeItem(key)
  } catch (error) {
    console.log(`Failed to remove 'sessionStorage' data:  ${error}`)
    return null
  }
}

export const removeAllSession = () => {
  try {
    return window?.sessionStorage?.clear()
  } catch (error) {
    console.log(`Failed to remove all 'sessionStorage' data:  ${error}`)
    return null
  }
}
